module.exports = __webpack_public_path__ + "static/media/really-bad.d248373e.gif";